ALLOWED_CONTROLLER = 'reports'
ALLOWED_ACTIONS = ['location_details']

class RentalsReportsController
  constructor: () ->
    @report_type_selector = $('#rental_reports')
    @report_type_selector.on('change', @load_graphs)
    @load_graphs()

  load_graphs: () =>
    report_name = @report_type_selector.val()
    graphs = $('.graph')
    graphs.each (index, element) ->
      $(element).data('json_url', $(element).data('url')+'&report='+report_name)
    $('a[data-selector="csv_link"]').each (index, element) ->
      $(element).attr('href', $(element).data('url')+'&report='+report_name)
    $('#report_name').val(report_name)
    PlotlyGraph.start_graph(graphs, 0)

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS) || !!document.querySelector('turbo-frame#location_details_report')
  controller = new RentalsReportsController()

$(document).ready(ready)
$(document).on('turbo:frame-render', ready)
